<script setup lang="ts">
    /**
     * Hero Widget
     * has the legacy name BackgroundHeader in the cms
     */
    import type { HeroData } from '~/@types/cms';
    import type { IWidgetProps } from '~/composables/widgets';

    const props = defineProps<IWidgetProps<HeroData>>();
    useProvideWidgetInfo(props);
</script>

<template>
    <mol-hero
        :data-index="componentIndex"
        :hero-data="data"
        :is-first-hero="componentIndex === 0"
        class="cms-background-header" />
</template>
